import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findConsultaLote from '../../service/findConsultaLote';
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { Messages } from 'primereact/messages';
import React from 'react';
import getConsultaLoteDownloadResultado from '../../service/getConsultaLoteDownloadResultado';
import postConsultaLoteReprocessar from '../../service/postConsultaLoteReprocessar';
import findClient from '../../service/findClient';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';




export default function ConsultaLoteList() {
  const { t } = useTranslation();
  const { state } = useGlobalState();
  const msgs = useRef<Messages>(null);
  const [consultasLote, setConsultasLote] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [clients, setClients] = useState<any>([]);
  const [selectedStatus, setSelectedStatus] = useState<any>(null);
  const [reprocessarVisible, setReprocessarVisible] = useState(false);
  const [reprocessarItem, setReprocessarItem] = useState<any>(null);

  const statusList = [
    { label: 'Incluído', value: 'INCLUIDO' },
    { label: 'Processando', value: 'PROCESSANDO' },
    { label: 'Processado', value: 'PROCESSADO' },
    { label: 'Erro', value: 'ERRO' }
  ];

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    cliente: null,
    status: null,
    idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'dataInclusao',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      cliente: selectedClient ? selectedClient.code : null,
      status: selectedStatus ? selectedStatus : null,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event:any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      cliente: selectedClient ? selectedClient.code : null,
      status: selectedStatus ? selectedStatus : null,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const changeCliente = (value:any) => {
    setSelectedClient(value);
    setlazyState({
      first: 0,
      rows: lazyState.rows,
      page: 1,
      cliente: value ? value.code : null,
      status: selectedStatus ? selectedStatus : null,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: lazyState.sortField,
      sortOrder: lazyState.sortOrder
    });
  };

  const changeStatus = (value:any) => {
    setSelectedStatus(value);
    setlazyState({
      first: 0,
      rows: lazyState.rows,
      page: 1,
      cliente: selectedClient ? selectedClient.code : null,
      status: value ? value : null,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: lazyState.sortField,
      sortOrder: lazyState.sortOrder
    });
  };

  const loadLazyData = () => {
    findConsultaLote(lazyState).then(data => {setTotalRecords(data.total);setConsultasLote(data.consultasLote)}).catch(() => {setTotalRecords(0);setConsultasLote(undefined)});
  }

  const downloadResponse = (consulta: any) => {
      getConsultaLoteDownloadResultado(consulta.id).then((blobFile: Blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blobFile], { type: "octet/stream" })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `resultado.csv`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        document.body.removeChild(link);
      });
    };

  const downloadTemplate = (consulta: any) => {
      return (
        <>
          {
            consulta.status == "Processado" && (
              <Button
                icon="pi pi-download"
                onClick={() => {
                  downloadResponse(consulta);
                }}
                style={{
                  background: "transparent",
                  color: "gray",
                  border: "none",
                }}
              />
            )}
          {
            consulta.status == "Processando" && state.user?.funcoes?.includes('CONSULTA_LOTE_REPROCESSAR') && (
              <Button
                icon="pi pi-refresh"
                tooltip="Reprocessar"
                onClick={() => {
                  confirmarReprocessar(consulta);
                }}
                style={{
                  background: "transparent",
                  color: "gray",
                  border: "none",
                }}
              />
            )}

        </>
      );
    };

  const confirmarReprocessar = (consulta: any) => {
    setReprocessarItem(consulta);
    setReprocessarVisible(true);
  };

  const reprocessar = () => {
    if (!reprocessarItem) return;
    setReprocessarVisible(false);
    postConsultaLoteReprocessar(reprocessarItem.id).then((data) => {
      msgs.current?.clear();
      msgs.current?.show([
        { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
      ]);
      setReprocessarItem(null);
      loadLazyData();
    }).catch((error) => {
      msgs.current?.clear();
      msgs.current?.show([
        { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: String(error), closable: false }
      ]);
      setReprocessarItem(null);
    });
  };

  const getStatusSeverity = (status: string) => {
    switch (status) {
      case 'Processado': return 'success';
      case 'Processando': return 'info';
      case 'Incluído': return 'secondary';
      case 'Erro': return 'danger';
      default: return 'info';
    }
  };

  const statusTemplate = (rowData: any) => {
    return (
      <Tag value={rowData.status} severity={getStatusSeverity(rowData.status) as any} />
    );
  };

  const startContent = (
    <React.Fragment>
      <div style={{ background: 'transparent' }}>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div>
              <div className="flex-auto" style={{visibility: state.user.cliente ? 'hidden': 'visible'}}>
                <label htmlFor="cliente" className="font-bold block mb-2">
                  {t("cliente")}{" "}
                </label>
                <Dropdown disabled={state.user.cliente} style={{width: '50%'}} value={selectedClient} onChange={(e) => {changeCliente(e.value)}} options={clients} optionLabel="name" placeholder="Selecione Cliente"
                                      showClear  filter className="w-full md:w-14rem" />
              </div>
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div>
              <div className="flex-auto">
                <label htmlFor="status" className="font-bold block mb-2">
                  {t("status")}{" "}
                </label>
                <Dropdown style={{width: '50%'}} value={selectedStatus} onChange={(e) => {changeStatus(e.value)}} options={statusList} optionLabel="label" optionValue="value" placeholder="Selecione Status"
                                      showClear className="w-full md:w-14rem" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  useEffect(() => {
    const lazyClient = {
      first: 0,
      rows: 99999999,
      page: 1,
      cliente: 'null',
      documento: 'null',
      codigo : 'null',
      inativo: null,
      idFranquia : state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: 'nome',
      sortOrder: SortOrder.DESC
    }
    const clientes : any[] = [];
    if(!state.user.cliente){
      findClient(lazyClient).then(data => {
        data.clientes.forEach( (c: { nome: string; id: string; }) => {
          clientes.push({name: c.nome, code:c.id})
        })
      })
    }

    setClients(clientes);
  }, []);

  useEffect(() => {
    loadLazyData();
  },[lazyState])

  return (
    <div>
      <Messages ref={msgs} />
      <Dialog header="Confirmação de Reprocessamento" visible={reprocessarVisible} style={{ width: '30vw' }} onHide={() => setReprocessarVisible(false)}
        footer={
          <div>
            <Button label="Cancelar" icon="pi pi-times" onClick={() => setReprocessarVisible(false)} className="p-button-text" />
            <Button label="Confirmar Reprocessamento" icon="pi pi-check" onClick={reprocessar} className="p-button-danger" />
          </div>
        }>
        {reprocessarItem && (
          <p><strong>Tem certeza que deseja reprocessar este lote?</strong></p>
        )}
      </Dialog>
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={consultasLote} first={lazyState.first} dataKey="id" paginator={true}  lazy={true}
                        emptyMessage="Sem registros"
                        onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                        rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
                        tableStyle={{ minWidth: '75rem' }}>
           <Column field="dataInclusao" sortable header={t('dtInclusao')}  />
           <Column field="opcaoConsultaLote" sortable header={t('opcao')}  />
           <Column field="cliente" header={t('cliente')}  />
           <Column field="usuario" header={t('usuario')}  />
           <Column field="status" sortable header={t('status')} body={statusTemplate}  />
           <Column field="quantidadeRegistro" sortable header={t('quantidadeRegistro')}  />
           <Column field="quantidadeSucesso" sortable header={t('quantidadeSucesso')}  />
           <Column field="quantidadeErro" sortable header={t('quantidadeErro')}  />
           <Column style={{width: '11%'}} header="Retorno Processamento" body={downloadTemplate} />
        </DataTable>
      </div>
    </div>
  )
}


